import {
  LuBell,
  LuBox,
  LuCheckCircle,
  LuDatabase,
  LuGlobe,
  LuList,
  LuLock,
  LuMessageSquare,
  LuTag,
  LuUsers,
} from 'react-icons/lu';

export const PROVIDER_CONFIG_FIELD_ICONS = {
  HOST: LuGlobe,
  AUTH_TYPE: LuLock,
  VERSION: LuTag,
  GET_STATE: LuCheckCircle,
  VDI_TYPES: LuList,
} as const;

export const PROVIDER_SERVICE_ICONS = {
  MMS: LuMessageSquare,
  VMS: LuDatabase,
  CLIENTS: LuUsers,
  ALERTS: LuBell,
  SMART_COOLERS: LuBox,
} as const;
